export { MaterialModule } from './lib/material.module';
